import { useEffect } from 'react';

/**
 *  If the video pauses, immediately un-pause it.
 */
export const useVideoElementPlayOnPause = (
  videoElementContainer: HTMLElement | HTMLVideoElement | undefined,
): void => {
  useEffect(() => {
    const videoElement = videoElementContainer
      ? videoElementContainer.tagName === 'VIDEO'
        ? (videoElementContainer as HTMLVideoElement)
        : videoElementContainer.querySelector('video')
      : undefined;

    const playOnPause = (): void => {
      videoElement?.play().catch(() => undefined);
    };

    if (videoElement) {
      if (videoElement.paused) {
        playOnPause();
      }
      videoElement.addEventListener('pause', playOnPause);
      return () => videoElement.removeEventListener('pause', playOnPause);
    } else {
      return () => undefined;
    }
  }, [videoElementContainer]);
};
